export default ({ adminSettings }) =>
  adminSettings.data?.time_zones?.map(({ name, value }, i) => ({
    id: i,
    label: name,
    value,
  }));
